import $ from 'jquery';
import stickybits from 'stickybits';
import ReadingPositionIndicator from '../vendor/rpi/rpi.js';


$(function () {


/* Read progress indicator
********************************************/

if ($('.js-reading-wrapper').length) {
	var rpi;
	setTimeout(function waitUntilDomIsReadyLoadingCustomFontsMightOffsetThis() {
		rpi = new ReadingPositionIndicator({
			rpiArea: '.js-reading-wrapper',
			progressBar: {
				show: true,
			},
			percentage: {
				show: false, // default false
				displayBeforeScroll: false, // default false
			},
		}).init();
	}, 1000);
}



/* Read time indicator
********************************************/

if ($('.js-has-reading-time').length) {
	$('.js-has-reading-time').each( function() {
		const $readingTime = $( this ).find( '.js-reading-time' );
		const $content = $( this ).find( '.js-reading-content' );

		if ( $readingTime && $readingTime.length && $content && $content.length ) {
			const text = $content[0].textContent;
			const wordCount = text.match(/\S+/g).length;
			const wpm = 250;
			let readingTimeInMinutes = 1;

			const readingTime = wordCount / wpm;
			const readingTimeModulo = readingTime - Math.floor(readingTime);

			if (wordCount > wpm) {
				if ((readingTimeModulo >= 0) && (readingTimeModulo < 0.8)) {
					readingTimeInMinutes = Math.floor(wordCount / wpm);
				} else {
					readingTimeInMinutes = Math.floor(wordCount / wpm) + 1;
				}
			}

			$readingTime.html(readingTimeInMinutes);
		}
	} );
}

if ($('.js-article-reading-time').length) {
	$(function () {
		const $readingContent = $('.js-article-reading-content .c-wysiwyg');

		let txt = '';

		$readingContent.children().each( function() {
			if ( ! $( this ).hasClass( 'c-promo-post' ) && ! $( this ).hasClass( 'c-promo-product' ) ) {
				txt = txt + $( this )[0].textContent;
			}
		} );

			var wordCount = txt.match(/\S+/g).length,
			wpm = 250,
			readingTimeInMinutes = 1;

		var readingTime = wordCount / wpm;
		var readingTimeModulo = readingTime - Math.floor(readingTime);
		if (wordCount > wpm) {
			if ((readingTimeModulo >= 0) && (readingTimeModulo < 0.8)) {
				readingTimeInMinutes = Math.floor(wordCount / wpm);
			} else {
				readingTimeInMinutes = Math.floor(wordCount / wpm) + 1;
			}
		}

		$('.js-article-reading-time').html(readingTimeInMinutes);
	});
}


/* Adding class on anchor that contains image
********************************************/

if ($('.c-article').length) {
	$('article p a:has(img), article .wp-caption a:has(img)').addClass('c-article__image-link');
	$('article img').closest('p').addClass('c-article__image-container');
}

/* Sticky sidebar
********************************************/

if ($('.js-sticky-sidebar').length) {
	const stickyHeaderHeight = $( '.site-header .main-nav' ).outerHeight( true );
	const stickyHeaderOffset = stickyHeaderHeight + 19;
	const stickySidebarHeight = $( '.js-sticky-sidebar' ).outerHeight( true );
	const stickySidebarVisibleHeight = $( '.js-sticky-sidebar .js-sticky-sidebar-visible' ).outerHeight( true );
	const stickySidebarOffset = stickyHeaderOffset - (stickySidebarHeight - stickySidebarVisibleHeight);

	$('.js-sticky-sidebar').css('top', stickySidebarOffset);
}


/* Sharing
********************************************/

if ($('.js-social-sharing').length) {
	$('.js-social-sharing .social-likes_expander').on('click', function (e) {
		e.preventDefault();
		$('.js-social-sharing').toggleClass('is-active');
	});
}



});
